export default __webpack_public_path__ + "static/media/about-img.1e1df721.png";